import React, { createContext, useContext } from 'react';

/**
 * SelectionContext provides selection state to all child components
 * This enables any card/dropdown to know about the current selection
 */
const SelectionContext = createContext({
  selectedIds: new Set(),
  selectedCount: 0,
  isMultiSelect: false,
  toggleSelection: (id) => {},
  clearSelection: () => {},
  isSelected: (id) => false,
});

// Custom hook to use the selection context
export const useSelectionContext = () => {
  const context = useContext(SelectionContext);
  if (!context) {
    throw new Error('useSelectionContext must be used within a SelectionProvider');
  }
  return context;
};

// Provider component
export const SelectionProvider = ({ children, value }) => {
  return (
    <SelectionContext.Provider value={value}>
      {children}
    </SelectionContext.Provider>
  );
};

export default SelectionContext;